import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { SendPostRequest } from "../../http";
// import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import "./CarousalSlider.css";

const CarousalSlider = () => {
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(1); // start with first real slide (because clone at 0)
  const [titleVisible, setTitleVisible] = useState(false);
  const [descVisible, setDescVisible] = useState(false);
  const sitedata = useSelector((store) => store.global.loginData);

  const wrapperRef = useRef(null);
  const titleTimeout = useRef(null);
  const descTimeout = useRef(null);
  const slideTimeout = useRef(null);

  const animations = ["from-left", "from-right", "from-top", "from-bottom", "zoom-in"];

  useEffect(() => {
    fetchSlides();
  }, []);

  useEffect(() => {
    if (!slides.length) return;
    animateSlide();
    return () => {
      clearTimeout(titleTimeout.current);
      clearTimeout(descTimeout.current);
      clearTimeout(slideTimeout.current);
    };
  }, [currentIndex, slides]);

  const fetchSlides = async () => {
    const siteTheme = sitedata?.options?.theme;
    const response = await SendPostRequest("branding/banners", {
      theme: siteTheme,
    });

    if (response?.data?.length) {
      // ✅ clones banaye (first aur last) infinite loop ke liye
      const clonedSlides = [
        response.data[response.data.length - 1],
        ...response.data,
        response.data[0],
      ];
      setSlides(clonedSlides);
    }
  };

  const animateSlide = () => {
    setTitleVisible(false);
    setDescVisible(false);

    titleTimeout.current = setTimeout(() => setTitleVisible(true), 1000);
    descTimeout.current = setTimeout(() => setDescVisible(true), 2000);

    slideTimeout.current = setTimeout(() => nextSlide(), 6000);
  };

  const nextSlide = () => {
    if (currentIndex >= slides.length - 1) return;

    setCurrentIndex((prev) => prev + 1);
  };

  const prevSlide = () => {
    if (currentIndex <= 0) return;

    setCurrentIndex((prev) => prev - 1);
  };

  // ✅ handle transition end → reset to real slide (loop effect)
  const handleTransitionEnd = () => {
    if (currentIndex === slides.length - 1) {
      wrapperRef.current.style.transition = "none"; // remove animation
      setCurrentIndex(1); // jump to first real slide
      setTimeout(() => {
        wrapperRef.current.style.transition = "transform 1s ease-in-out";
      }, 50);
    }

    if (currentIndex === 0) {
      wrapperRef.current.style.transition = "none";
      setCurrentIndex(slides.length - 2); // jump to last real slide
      setTimeout(() => {
        wrapperRef.current.style.transition = "transform 1s ease-in-out";
      }, 50);
    }
  };

  return (
    <div className="new-carousal-banner-slider">
      <div
        className="new-carousal-banner-slider-wrapper"
        ref={wrapperRef}
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
        onTransitionEnd={handleTransitionEnd} // ✅ loop reset trigger
      >
        {slides.map((slide, index) => {
          const animationClass = animations[index % animations.length];

          return (
            <div className="new-carousal-banner-slide" key={index}>
              <div className="new-carousal-banner-slide-image">
                {slide?.banner_category === "custom-text" && (
                <div className="shadow"></div>
                )}
                <img src={slide?.banner_image} alt={slide?.banner_title} />
                <div className="new-carousal-banner-shadow"></div>
              </div>
              <div className="container">
                {slide?.banner_category === "custom-text" && (
                  <div
                    className={`new-carousal-banner-slide-content ${slide?.banner_alignment === "right" ? "align-left" : "align-center"
                      }`}
                  >
                    <h2
                      className={`new-carousal-banner-slide-title banner-title-font ${animationClass} ${titleVisible ? "visible" : ""
                        }`}
                    >
                      {slide?.banner_title}
                    </h2>
                    <p
                      className={`new-carousal-banner-slide-description ${animationClass} ${descVisible ? "visible" : ""
                        }`}
                    >
                      {slide?.banner_description}
                    </p>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <button className="new-carousal-banner-arrow left-arrow" onClick={prevSlide}>
        <IoIosArrowBack />
      </button>
      <button className="new-carousal-banner-arrow right-arrow" onClick={nextSlide}>
        <IoIosArrowForward />
      </button>
    </div>
  );
};

export default CarousalSlider;
